import Button from "./Button";

/**
 * CancelButton - Pre-styled button for cancel actions
 * 
 * Light gray background with dark gray text, commonly used in app bars and navigation
 * 
 * @param {Object} props - All Button props are supported
 * @param {React.ReactNode} props.children - Button content
 * @param {function} props.onClick - Click handler
 * @param {boolean} props.disabled - Whether button is disabled
 * 
 * @example
 * <CancelButton onClick={handleCancel}>Cancel</CancelButton>
 */
const CancelButton = ({ children = "Cancel", ...props }) => {
  return (
    <Button
    {...props}
    size="sm"
    className={`app-btn-cancel ${props.className || ""}`}
    >
      {children}
    </Button>
  );
};

export default CancelButton;

